export default {
  partOfTeam: {
    title: 'Venha Fazer Parte do #timeSIS!',
    description:
      'Nós temos a vaga ideal para você. Venha fazer parte de uma empresa que acolhe o colaborador, oferece diversos benefícios e apoia o seu desenvolvimento.',
    buttonText: 'Venha ser SIS',
  },
}
